import { render, staticRenderFns } from "./RequestDemo.vue?vue&type=template&id=80366d82"
import script from "./RequestDemo.vue?vue&type=script&lang=js"
export * from "./RequestDemo.vue?vue&type=script&lang=js"
import style0 from "./RequestDemo.vue?vue&type=style&index=0&id=80366d82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports